import { createTheme } from "@mui/material/styles";
import { colors } from "./common";

export const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary
    },
    secondary: {
      main: colors.black
    }
  }
});
